import React from "react";
import DoctorListComponent from "../components/doctor-list-component";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Container } from "react-bootstrap";

const DoctorsList = () => {
  return (
    <>
      <Navbar />
      <Container className="mt-3">
        <DoctorListComponent />
      </Container>
      <Footer />
    </>
  );
};

export default DoctorsList;
